<template>
  <div style="margin-top: 30px">
    <h2>Featured Spotlights:</h2>
    <SpotlightSlide />
    <h2>See What Our Current Students Are Up To:</h2>
    <div style="padding: 30px">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="8"
          ><Tweet id="1308092243002220544"
            ><i class="el-icon-loading"></i></Tweet
        ></el-col>
        <el-col :span="8"
          ><Tweet id="1309131014317445126"
            ><i class="el-icon-loading"></i></Tweet
        ></el-col>
        <el-col :span="8"
          ><Tweet id="1306759981103017985"
            ><i class="el-icon-loading"></i></Tweet
        ></el-col>
      </el-row>
    </div>
    <!--<Moment id="1309744934673620993" />-->
  </div>
</template>

<script>
import SpotlightSlide from "../components/SpotlightSlide";
import { Tweet } from "vue-tweet-embed";

export default {
  components: { SpotlightSlide, Tweet },
};
</script>

<style scoped>
.el-col {
  padding: 15px;
}
</style>
